
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M29 31H3a1 1 0 01-1-1V2a1 1 0 011-1h20a1 1 0 01.71.29l6 6A1 1 0 0130 8v22a1 1 0 01-1 1zM4 29h24V8.41L22.59 3H4z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M20 9H10a1 1 0 01-1-1V2a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1zm-9-2h8V3h-8zM23 25H9a1 1 0 01-1-1V14a1 1 0 011-1h14a1 1 0 011 1v10a1 1 0 01-1 1zm-13-2h12v-8H10z"}})])
          )
        }
      }
    